export const CREATEPOST = 'posts/createPost';
export const GETPOSTS = 'posts/getPosts';
export const UPDATEPOST = 'posts/updatePost';
export const DELETEPOST = 'posts/deletePost';
export const LIKEPOST = "posts/likePost";
export const GETPOSTBYSEARCH = "posts/getPostBysearch";
export const GETPOST = "posts/getPost";
export const COMMENTPOST = "posts/commentPost";